module.exports = __webpack_public_path__ + "img/herb-sage-190x100.3c2328f8.jpg";